module.exports = __webpack_public_path__ + "img/ico-plane.ca2cac2a.svg";